import React, { useMemo } from 'react';
import { MARK } from '../../../constants';
import PrenhasPorCliente, { dataBR } from '../shared/PrenhasPorCliente';
import {
  prenhasDeAgora, prenhasPorCliente, resumoDasPrenhas, situacaoDaPrenha,
} from '../../../utils/calculations/prenhas';
import { Destaque, Indicador, Vazio, BotaoPDF, num } from './Pecas';
import { gerarRelatorioPDF, descreverFiltros } from '../../../utils/relatorioPDF';

/**
 * Receptoras prenhas: quem está prenha hoje, de cada cliente, e quando pare.
 *
 * Como o sêmen, é um RETRATO e não tem período: ou ela está prenha hoje, ou não
 * está. A taxa do período continua na aba Prenhez.
 */
const PainelPrenhas = ({ linhas, contexto = {} }) => {
  const prenhas = useMemo(() => prenhasDeAgora(linhas), [linhas]);
  const grupos = useMemo(() => prenhasPorCliente(prenhas), [prenhas]);
  const r = useMemo(() => resumoDasPrenhas(prenhas), [prenhas]);

  const INDICADORES = [
    { rotulo: 'Confirmadas', valor: num(r.confirmadas), detalhe: 'prenhes na DG60' },
    { rotulo: 'Aguardam DG60', valor: num(r.aguardam), detalhe: 'prenhes na DG30' },
    { rotulo: 'Próximo parto', valor: dataBR(r.proximo_parto), detalhe: 'TE + 280 dias' },
  ];

  const imprimir = () => gerarRelatorioPDF({
    titulo: 'Receptoras prenhas',
    laboratorio: contexto.laboratorio,
    filtros: descreverFiltros(contexto),
    indicadores: [
      { rotulo: 'Prenhas', valor: num(r.total), detalhe: `${num(r.clientes)} cliente(s)` },
      ...INDICADORES,
    ],
    detalhe: {
      titulo: 'Receptoras',
      colunas: [
        { chave: 'cli', rotulo: 'Cliente', valor: (p) => p.client_name || '—' },
        { chave: 'rec', rotulo: 'Receptora', valor: (p) => p.recipient_identifier || '—' },
        { chave: 'doa', rotulo: 'Doadora', valor: (p) => p.doadora || '—' },
        { chave: 'tou', rotulo: 'Touro', valor: (p) => p.touro || '—' },
        { chave: 'sex', rotulo: 'Sexo', valor: (p) => p.fetus_sex || '—' },
        { chave: 'te', rotulo: 'TE', valor: (p) => dataBR(p.te_date) },
        { chave: 'par', rotulo: 'Parto previsto', forte: true, valor: (p) => dataBR(p.parto_previsto) },
        { chave: 'sit', rotulo: 'Situação', valor: (p) => situacaoDaPrenha(p, MARK) },
      ],
      linhas: grupos.flatMap(g => g.prenhas),
    },
  });

  if (prenhas.length === 0) return <Vazio mensagem="Nenhuma receptora prenha agora." />;

  return (
    <div className="space-y-5">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <Destaque rotulo="Receptoras prenhas" valor={num(r.total)} detalhe={`${num(r.clientes)} cliente(s)`} />
        <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-3 gap-4">
          {INDICADORES.map(i => <Indicador key={i.rotulo} {...i} />)}
        </div>
      </div>

      <div className="flex justify-end">
        <BotaoPDF onClick={imprimir} />
      </div>
      {/* A chave recomeça o grupo aberto quando o filtro de cliente muda. */}
      <PrenhasPorCliente key={grupos.map(g => g.chave).join()} grupos={grupos} />
    </div>
  );
};

export default PainelPrenhas;
